import { BlockOverrides } from 'baseui/block';
import { DARK_MUTED } from '@lyon/utils/theme/colors/darkmuted';
import { ITabOverrides } from '@lyon/components/utils/ContentWideTabs';

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      height: '100%',
      width: '100%',
    },
  },
};

export const TAB: ITabOverrides = {
  tab: {
    Tab: {
      style: ({ $active, $theme }) => ({
        color: $active ? $theme.colors.white : $theme.colors.primaryA,
        width: '100%',
        marginLeft: 0,
        marginRight: 0,
        paddingTop: '8px',
        paddingLeft: '32px',
        paddingRight: '32px',
        paddingBottom: '8px',
        textAlign: 'center',
        borderBottom: `
        ${$active ? '2px' : 0}
        ${$active ? 'solid' : 'none'}
        ${$active ? $theme.colors.primary : 'none'}
      `,
        ...$theme.typography.font250,

        backgroundColor: $active
          ? DARK_MUTED.darkmuted500
          : DARK_MUTED.darkmuted600,
      }),
    },
  },
};
